import { API } from '@/api';
import { fetcher } from '@/services/fetcher';
import { toURLSearchParams } from '@/utils/url';

import { type ProductsParams, productsResponseSchema } from '../../models';

const masterDataApi = fetcher.extend(() => ({ prefixUrl: `${API.MASTER_DATA_PUBLIC}` }));

export const fetchProducts = (params: ProductsParams, { signal }: { signal?: AbortController['signal'] } = {}) => {
  const { limit = 10, offset = 0, productCode, productDesc, sorting } = params;

  return masterDataApi
    .get('product-master', {
      searchParams: toURLSearchParams({
        'InlineSearch[productCode]': productCode || undefined,
        'InlineSearch[productDesc]': productDesc || undefined,
        Skip: offset,
        Sorting: sorting || 'productCode asc',
        Take: limit,
      }),
      signal,
    })
    .json(productsResponseSchema);
};
